import React from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { reviewDesk } from '@/design-system';
import { useTranslation } from '@/hooks/useTranslation';

interface PracticeExamCardProps {
  onPress: () => void;
}

export function PracticeExamCard({ onPress }: PracticeExamCardProps) {
  const { t } = useTranslation();
  return (
    <View style={styles.card} testID="progress_practice_exam_card">
      <View style={styles.icon}>
        <MaterialIcons name="quiz" size={24} color={reviewDesk.accent} />
      </View>
      <View style={styles.copy}>
        <Text style={styles.eyebrow}>{t('icfProgress.practiceExam.eyebrow')}</Text>
        <Text style={styles.title}>{t('icfProgress.practiceExam.entryTitle')}</Text>
        <Text style={styles.body}>{t('icfProgress.practiceExam.entryBody')}</Text>
      </View>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={t('icfProgress.practiceExam.entryCta')}
        onPress={onPress}
        style={({ pressed }) => [styles.button, pressed && styles.pressed]}
      >
        <Text style={styles.buttonText}>{t('icfProgress.practiceExam.entryCta')}</Text>
        <MaterialIcons name="arrow-forward" size={18} color="#FFFFFF" />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    width: '100%',
    borderWidth: 1,
    borderColor: reviewDesk.line,
    borderRadius: 16,
    backgroundColor: reviewDesk.card,
    padding: 18,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 14,
  },
  icon: {
    width: 46,
    height: 46,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: reviewDesk.accentSoft,
  },
  copy: { flex: 1, minWidth: 220, gap: 3 },
  eyebrow: { color: reviewDesk.accent, fontSize: 11, fontWeight: '800', textTransform: 'uppercase', letterSpacing: 0.5 },
  title: { color: reviewDesk.ink, fontSize: 17, lineHeight: 22, fontWeight: '800' },
  body: { color: reviewDesk.inkSoft, fontSize: 13, lineHeight: 19 },
  button: {
    minHeight: 42,
    borderRadius: 10,
    backgroundColor: reviewDesk.accent,
    paddingHorizontal: 15,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
  },
  buttonText: { color: '#FFFFFF', fontSize: 13, fontWeight: '800' },
  pressed: { opacity: 0.72 },
});

export default PracticeExamCard;
